import './App.css';
import BotsPage from './components/BotsPage';


function App() {
  return (
    <div className="App">
      <BotsPage/>
    </div>
  );
}

export default App;
